<template>
    <div class="companies">
        <div class="content">
            <div class="wrap">
                <div class="wrap__tree">
                    <div class="nav-tree">
                        <el-button v-if="user.access" :disabled="!user.access.createCompany" @click="openModal" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_companies_addCompany')}}</el-button>
                    </div>
                    <el-table
                            max-height="700"
                            :data="user.companyList"
                            style="width: 100%"
                            :empty-text="$t('general_noData')"
                            :cell-class-name="cellClassName"
                            :row-class-name="tableRowClassName"
                            :header-cell-class-name="headerCellClassName"
                            @cell-click="cellClick">
                        <el-table-column

                                label=""
                                width="80">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.isOwnCompany"
                                           size="mini"
                                           type="success"
                                           circle></el-button>
                                <el-button v-else
                                           size="mini"
                                           type="info"
                                           circle></el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                          label="ID"
                          type="index"
                          width="50">
                        </el-table-column>
                        <el-table-column
                                :label="$t('settings_companiesID')"
                                width="90">
                            <template slot-scope="scope">
                                  <span v-if="String(scope.row.id).length == 1">
                                    ID-000{{scope.row.id}}
                                  </span>
                                  <span v-if="String(scope.row.id).length == 2">
                                    ID-00{{scope.row.id}}
                                  </span>
                                  <span v-if="String(scope.row.id).length == 3">
                                    ID-0{{scope.row.id}}
                                  </span>
                                  <span v-if="String(scope.row.id).length == 4">
                                    ID-{{scope.row.id}}
                                  </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                :label="$t('settings_companies_name')">
                        </el-table-column>
                        <el-table-column
                                prop="email"
                                :label="$t('settings_companies_email')"
                                width="190">
                        </el-table-column>
                        <el-table-column
                                :label="$t('settings_companies_rate')"
                                width="130">
                            <template slot-scope="scope">
                                <span v-html="scope.row.companyRateName"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                :label="$t('settings_companies_rateExpiredDate')"
                                width="130">
                            <template slot-scope="scope">
                                  <span v-if="scope.row.companyRateExpiredDate != 1">
                                    <span v-if="scope.row.companyRateExpiredDate">
                                      {{moment(scope.row.companyRateExpiredDate * 1000).format("D MMM YY")}}
                                    </span>
                                    <span v-else></span>
                                  </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                :label="$t('settings_companies_createDate')"
                                width="90">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.createDate">
                                      {{moment(scope.row.createDate).format("D MMM YY")}}
                                    </span>
                                    <span v-else></span>
                                </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                :index="6"
                                width="75"
                                :label="$t('settings_companies_operations')">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.isOwnCompany"
                                           size="mini"
                                           type="primary"
                                           plain
                                           @click="handleEdit(scope.$index, scope.row)">{{$t('settings_companies_edit')}}</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                :index="7"
                                width="115">
                            <template slot-scope="scope">
                                <el-button
                                        v-if="scope.row.isOwnCompany"
                                        size="mini"
                                        type="primary"
                                        plain
                                        @click="pay(scope.row)">
                                    {{$t('settings_companies_pay')}}
                                </el-button>
                            </template>

                        </el-table-column>
                        <el-table-column
                                align="center"
                                :label="$t('settings_companies_active')"
                                width="70">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.id.toString() === activeCompany.toString()"
                                           size="mini"
                                           type="primary"
                                           circle
                                           icon="el-icon-check"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>
            </div>
        </div>

        <!-- add -->
        <sweet-modal blocking :title="$t('modal_settings_addCompany')" :hide-close-button="blocking" ref="company" class="modal" v-on:close="closeModal">

            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="0" class="demo-ruleForm">

                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="companyName">
                            <el-input :label="$t('modal_settings_CompanyName')" v-model="form.companyName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item class="company-logo-block" label-position="left" :label="$t('modal_settings_companyLogo')" label-width="90px">
                            <el-upload
                                    class="logo-uploader"
                                    action=""
                                    :show-file-list="false"
                                    :http-request="handleLogoSuccessAdd"
                                    :before-upload="beforeLogoUpload">
                                <img v-if="form.logoUrl" :src="form.logoUrl" class="logo">
                                <i v-else class="el-icon-plus logo-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item style="margin-bottom: 0;">
                            <el-input v-model="form.taxNumber" :label="$t('modal_settings_taxNumber')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="currencyCode" style="margin-bottom: 0;">
                            <el-select v-model="form.currencyCode" :placeholder="$t('modal_settings_currencyCompany')" filterable style="width: 100%;">
                                <el-option v-for="item in currencyList"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-divider></el-divider>

                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item>
                            <el-input :label="$t('modal_settings_tradingName')" v-model="form.tradingName"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item>
                      <el-date-picker
                        v-model="form.financialYearStartDate"
                        type="date"
                        placeholder="Financial Year Start Date"
                        value-format="dd-MM-yyyy"
                        style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item>
                            <el-select v-model="form.businessType" :placeholder="$t('modal_settings_businessType')" filterable style="width: 100%;">
                                <el-option
                                        v-for="item in businessTypeList"
                                        :key="item.id"
                                        :label="item.lable"
                                        :value="item.lable">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item>
                            <el-date-picker
                                    v-model="form.startedOn"
                                    type="date"
                                    :placeholder="$t('modal_settings_startedOn')"
                                    value-format="dd/MM/yyyy"
                                    style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item>
                            <el-input :label="$t('modal_settings_website')" v-model="form.website"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="email" style="margin-bottom: 0;">
                          <el-input v-model="form.email" :label="$t('modal_settings_companyEmail')"></el-input>
                      </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item>
                            <el-input type="number" :label="$t('modal_settings_phone')" v-model="form.primaryPhone"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item>
                            <el-input :label="$t('modal_settings_fax')" v-model="form.fax"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item>
                            <el-input :label="$t('modal_settings_totalEmployess')" v-model="form.totalEmployess"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <el-switch v-model="form.isAddressAssigned" :active-text="$t('modal_address')"></el-switch>
                      </el-form-item>
                    </el-col>
                </el-row>

                <el-row v-if="form.isAddressAssigned" :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="countryId">
                        <el-select no-data-text="no data" v-model="form.countryId" :placeholder="$t('modal_settings_country')" filterable style="width: 100%;">
                            <el-option
                                    v-for="item in arrCountryId"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    @click.native="setState(item.id)">
                                <!-- @click.native="setState(item.id)" -->
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="stateId">
                        <el-select no-data-text="no data" v-model="form.stateId" :placeholder="$t('modal_settings_stateProvinceCountry')" filterable style="width: 100%;">
                            <el-option
                                    v-for="item in arrStateId"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    @click.native="setCity(item.id)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="form.isAddressAssigned" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="cityId">
                            <el-select no-data-text="no data" v-model="form.cityId" :placeholder="$t('modal_settings_city')" filterable style="width: 100%;">
                                <el-option
                                        v-for="item in arrCityId"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item>
                          <el-input v-model="form.postCode" :label="$t('modal_post_code')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row v-if="form.isAddressAssigned" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="address">
                            <el-input :label="$t('modal_address_line_1')" v-model="form.address"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item>
                            <el-input :label="$t('modal_address_line_2')" v-model="form.address2"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row v-if="form.isAddressAssigned" :gutter="20">
                  <el-col :span="12">
                    <el-form-item>
                      <el-input v-model="form.address3" :label="$t('modal_address_line_3')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12"></el-col>
                </el-row>

                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('company')">{{$t('general_cancel')}}</el-button>
                    <el-button @click="submitForm('form')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <!-- edit -->
        <sweet-modal blocking :title="$t('modal_settings_editCompany')" ref="editCompany" class="modal-edit" v-on:close="editCompanyclose">

            <!--{{activeEditModalTab}}-->
            <el-tabs v-model="activeEditModalTab" type="card">
                <el-tab-pane name="general" :label="$t('modal_settings_general')"></el-tab-pane>
                <el-tab-pane name="additional" :label="$t('modal_settings_additional')"></el-tab-pane>
                <el-tab-pane v-if="formGet.countryId === 103" name="statutory" :label="$t('modal_settings_statutory_information')"></el-tab-pane>
            </el-tabs>
            <el-form :model="formGet" status-icon ref="formGet" label-position="left" :rules="rulesEdit" class="form-get">
                <div v-show="activeEditModalTab === 'general'">

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item prop="name">
                                <el-input :label="$t('modal_settings_CompanyName')" v-model="formGet.name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item class="company-logo-block" label-position="left" :label="$t('modal_settings_companyLogo')" label-width="90px">
                                <el-upload
                                        class="logo-uploader"
                                        action=""
                                        :show-file-list="false"
                                        :http-request="handleLogoSuccess"
                                        :before-upload="beforeLogoUpload">
                                    <img v-if="formGet.logoUrl" :src="formGet.logoUrl" class="logo">
                                    <i v-else class="el-icon-plus logo-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item style="margin-bottom: 0;">
                              <el-input v-model="formGet.taxNumber" :label="$t('modal_settings_taxNumber')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="currencyCode" style="margin-bottom: 0;">
                                <el-select v-model="formGet.currencyCode" :placeholder="$t('modal_settings_currencyCompany')" filterable style="width: 100%;">
                                    <el-option v-for="item in currencyList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-divider></el-divider>

                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item>
                                <el-input :label="$t('modal_settings_tradingName')" v-model="formGet.tradingName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                      <el-col :span="24" :offset="0">
                        <el-form-item>
                          <el-date-picker
                            v-model="formGet.financialYearStartDate"
                            type="date"
                            placeholder="Financial Year Start Date"
                            value-format="dd-MM-yyyy"
                            style="width: 100%;">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item>
                                <el-select v-model="formGet.businessType" :placeholder="$t('modal_settings_businessType')" filterable style="width: 100%;">
                                    <el-option
                                            v-for="item in businessTypeList"
                                            :key="item.id"
                                            :label="item.lable"
                                            :value="item.lable">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item>
                                <el-date-picker
                                        v-model="formGet.startedOn"
                                        type="date"
                                        :placeholder="$t('modal_settings_startedOn')"
                                        value-format="dd/MM/yyyy"
                                        style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item>
                                <el-input :label="$t('modal_settings_website')" v-model="formGet.website"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="email" style="margin-bottom: 0;">
                              <el-input :label="$t('modal_settings_companyEmail')" v-model="formGet.email"></el-input>
                          </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item>
                                <el-input type="number" :label="$t('modal_settings_phone')" v-model="formGet.primaryPhone"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item>
                                <el-input :label="$t('modal_settings_fax')" v-model="formGet.fax"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item>
                                <el-input :label="$t('modal_settings_totalEmployess')" v-model="formGet.totalEmployess"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <el-switch v-model="formGet.isAddressAssigned" :active-text="$t('modal_address')"></el-switch>
                          </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="formGet.isAddressAssigned" :gutter="20">
                      <el-col :span="12">
                        <el-form-item prop="countryId">
                            <el-select no-data-text="no data" v-model="formGet.countryId" :placeholder="$t('modal_settings_country')" filterable style="width: 100%;">
                                <el-option
                                        v-for="item in arrCountryId"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="setStateUpdate(item.id)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item prop="stateId">
                            <el-select no-data-text="no data" v-model="formGet.stateId" :placeholder="$t('modal_settings_stateProvinceCountry')" filterable style="width: 100%;">
                                <el-option
                                        v-for="item in arrStateId"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="setCityUpdate(item.id)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row v-if="formGet.isAddressAssigned" :gutter="20">
                        <el-col :span="12">
                            <el-form-item prop="cityId">
                                <el-select no-data-text="no data" v-model="formGet.cityId" :placeholder="$t('modal_settings_city')" filterable style="width: 100%;">
                                    <el-option
                                            v-for="item in arrCityId"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item>
                              <el-input v-model="formGet.postCode" :label="$t('modal_post_code')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="formGet.isAddressAssigned" :gutter="20">
                        <el-col :span="12">
                            <el-form-item prop="address">
                                <el-input :label="$t('modal_address_line_1')" v-model="formGet.address"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item>
                                <el-input :label="$t('modal_address_line_2')" v-model="formGet.address2"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="formGet.isAddressAssigned" :gutter="20">
                      <el-col :span="12">
                        <el-form-item>
                          <el-input v-model="formGet.address3" :label="$t('modal_address_line_3')"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12"></el-col>
                    </el-row>

                </div>

                <div v-show="activeEditModalTab === 'additional'">
                    <!-- <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="ID:" label-width="80px" prop="companyId">
                                <el-input disabled :placeholder="$t('modal_settings_companyId')" v-model="formGet.companyId"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row> -->

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item :label="$t('modal_settings_category')" label-width="80px" prop="categoryId">
                                <!-- <el-autocomplete
                                        popper-class="my-autocomplete"
                                        v-model="formGet.categoryListInput"
                                        :fetch-suggestions="querySearchCategory"
                                        :placeholder="$t('modal_settings_category')"
                                        @select="handleSelectCategory">
                                    <el-button
                                            class="add-btn"
                                            v-if="isEmptyCategory"
                                            size="mini"
                                            type="primary"
                                            slot="append"
                                            pain
                                            @click="handleIconClickCategory">Add</el-button>
                                    <template slot-scope="{ item }">
                                        <div class="value">{{ item.name }}</div>
                                    </template>
                                </el-autocomplete> -->

                                <el-select no-data-text="no data" v-model="formGet.categoryId" :placeholder="$t('modal_settings_category')" filterable style="width: 100%;">
                                  <el-option
                                    v-for="item in categoryList2"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                            <el-form-item class="company-logo-block" label-position="left" :label="$t('modal_settings_companyLogo')" label-width="90px">
                                <el-upload
                                        class="logo-uploader"
                                        action=""
                                        :show-file-list="false"
                                        :http-request="handleLogoSuccess"
                                        :before-upload="beforeLogoUpload">
                                    <img v-if="formGet.logoUrl" :src="formGet.logoUrl" class="logo">
                                    <i v-else class="el-icon-plus logo-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col> -->
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item :label="$t('modal_settings_description')" label-width="80px" prop="briefDescription">
                                <el-input :placeholder="$t('modal_settings_briefDescription')" v-model="formGet.briefDescription"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('modal_settings_classification')" label-width="90px" prop="classificationId">
                                <!-- <el-autocomplete
                                        popper-class="my-autocomplete"
                                        v-model="formGet.classificationListInput"
                                        :fetch-suggestions="querySearchClassification"
                                        :placeholder="$t('modal_settings_classification')"
                                        @select="handleSelectClassification">
                                    <el-button
                                            class="add-btn"
                                            v-if="isEmptyClassification"
                                            size="mini"
                                            type="primary"
                                            slot="append"
                                            pain
                                            @click="handleIconClickClassification">Add</el-button>
                                    <template slot-scope="{ item }">
                                        <div class="value">{{ item.name }}</div>
                                    </template>
                                </el-autocomplete> -->

                                <el-select no-data-text="no data" v-model="formGet.classificationId" :placeholder="$t('modal_settings_classification')" filterable style="width: 100%;">
                                  <el-option
                                    v-for="item in classificationList2"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item :label="$t('modal_settings_header')" label-width="80px" prop="reportHeader">
                                <el-input :placeholder="$t('modal_settings_reportHeader')" v-model="formGet.reportHeader"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('modal_settings_signatory')" label-width="90px" prop="companySignatory">
                                <el-input :placeholder="$t('modal_settings_signatory')" v-model="formGet.companySignatory"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item :label="$t('modal_settings_tinOfSignatory')" label-width="80px" prop="tinOfSignatory">
                                <el-input :placeholder="$t('modal_settings_tinOfSignatory')" v-model="formGet.tinOfSignatory"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('modal_settings_titlePositionOfSignatory')" label-width="90px" prop="tinOfSignatory">
                                <el-input :placeholder="$t('modal_settings_titlePositionOfSignatory')" v-model="formGet.titlePositionOfSIgnatory"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </div>
                <div v-show="activeEditModalTab === 'statutory'">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label-position="left" label-width="70px" :label="$t('modal_settings_barangay')" prop="barangay">
                                <el-input :placeholder="$t('modal_settings_barangay')" v-model="formGet.barangay"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label-position="left" label-width="75px" label="SSS #:" prop="sss">
                                <el-input placeholder="00-0000000-0" v-mask="'##-#######-#'" v-model="formGet.sss"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label-position="left" label-width="70px" label="PHIC #:" prop="phic">
                                <el-input placeholder="00-000000000-0" v-mask="'##-#########-#'" v-model="formGet.phic"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label-position="left" label-width="75px" label="HDMF #:">
                                <el-input placeholder="000000000000" v-mask="'############'" v-model="formGet.hdmf"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label-position="left" label-width="70px" label="TIN #:" prop="tin">
                                <el-input placeholder="000-000-000-000" v-mask="'###-###-###-###'" v-model="formGet.tin"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label-position="left" label-width="75px" :label="$t('modal_settings_rdoCode')">
                                <el-input :placeholder="$t('modal_settings_rdoCode')" v-model="formGet.rdo"></el-input>
                                <span>({{$t('modal_settings_revenueDistrictOffice')}})</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-divider></el-divider>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('editCompany')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="editCompany('formGet')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <createCompanyCategoryModal  @setNewCategory="setNewCategory" v-model="formGet.categoryListInput" ref="createCompanyCategoryModal"/>
        <createCompanyClassificationModal  @setNewClassification="setNewClassification" v-model="formGet.classificationListInput" ref="createCompanyClassificationModal"/>

        <!-- [ Modal add region] start -->

        <!-- [ Modal are you sure] start -->
        <!--<sweet-modal ref="confirmation" title="Delete region">-->
        <!--Are you sure you want to delete this region?-->
        <!--<template slot="box-action">-->
        <!--<a class="button" @click="deleteConfirm">Ok</a> &nbsp;-->
        <!--<a class="button" @click="$refs.confirmation.close()">Cancel</a>-->
        <!--</template>-->
        <!--</sweet-modal>-->
        <!-- [ Modal are you sure] end -->

        <!-- [ success modal] end -->
        <!--<sweet-modal ref="success" icon="success">-->
        <!--Edit successfully-->
        <!--</sweet-modal>-->
        <sweet-modal class="addSuccess" id="addSuccess" ref="addSuccess" icon="success">
            Congratulation,<br>
            Company successfully created, you can now select it from your company list.
        </sweet-modal>
        <!-- [ success modal] end -->
    </div>
</template>

<script>
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'
  import createCompanyCategoryModal from '@/components/settings/companyCategories/createCompanyCategoryModal'
  import createCompanyClassificationModal from '@/components/settings/companyClassifications/createCompanyClassificationModal'

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  // import {AgGridVue} from "ag-grid-vue"

  function valFormatter(params) {
    return moment(params.data.createDate.toString(), 'X').format('DD MMMM YYYY')
  }

  export default {
    name: 'my-companies',
    components: {
      // Header,
      // Menu,
      // AgGridVue,
      SweetModal,

      createCompanyCategoryModal,
      createCompanyClassificationModal
    },
    beforeCreate() {
    },
    beforeMount() {
      // this.gridOptions = {
      //   suppressCellSelection: true
      // };
      // this.columnDefs = [
      //   { field: "id", },
      //   { field: "name",
      //     width: 320, },
      //   { field: "email" },
      //   { field: 'createDate',
      //     valueFormatter: valFormatter,
      //     function(params) {
      //       return moment(params.data.createDate.toString(), 'X').format('DD MMMM YYYY')
      //     }
      //   }
      // ];
      // this.defaultColDef = {
      //   resizable: true,
      //   width: 150,
      //   sortable: true,
      //   filter: true
      // };
      // this.rowSelection = "single";
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    mounted(){
      if(this.$route.query.companyId){
        this.GetCompanies()
      }else if(!this.$route.query.companyId){
        this.openModal()
        this.blocking = true
      }
      // this.gridApi = this.gridOptions.api
      // this.gridColumnApi = this.gridOptions.columnApi;
      // this.gridApi.sizeColumnsToFit();
    },
    data() {
      return {
        selectedRowId: '',
        activeCompany: this.$route.query.companyId,
        moment:moment,
        blocking: false,
        // selectedRow: {},
        modalAdd: false,
        modalEdit:false,
        // companyNameSelect: '',
        // open: false,

        // addRegionToggle: true,
        // rowData: null,
        companyId: '',

        currencyList: [],

        businessTypeList: [{
          id: 1,
          lable: 'Company'
        }, {
          id: 2,
          lable: 'Sole Trader'
        }, {
          id: 3,
          lable: 'Individual'
        }, {
          id: 4,
          lable: 'Charity'
        }, {
          id: 5,
          lable: 'NGO'
        }, {
          id: 6,
          lable: 'Government'
        }, {
          id: 7,
          lable: 'Sports Group'
        }, {
          id: 8,
          lable: 'Not For Profit'
        }],
        arrCountryId: [],
        arrStateId: [],
        arrCityId: [],
        form:{
          logoUrl: '',
          companyName:'',
          organization: '',
          tradingName: '',
          financialYearStartDate: null,
          businessType: '',
          email:'',
          fax: '',
          currencyCode: '',
          // businessDomain: '',
          taxNumber: '',
          website: '',
          totalEmployess: '',
          startedOn: '',
          primaryPhone: '',
          // todo
          isAddressAssigned: false,
          countryId: null,
          stateId: null,
          cityId: null,
          address: null,
          address2: null,
          // todo
          address3: null,
          postCode: null,
        },
        formGet: {
          companyId: '',
          name: '',
          organization: '',
          tradingName: '',
          financialYearStartDate: null,
          businessType: '',
          email: '',
          fax: '',
          currencyCode: '',
          // businessDomain: '',
          taxNumber: '',
          website: '',
          totalEmployess: '',
          startedOn: '',
          primaryPhone: '',
          // todo
          isAddressAssigned: false,
          countryId: null,
          stateId: null,
          cityId: null,
          address: null,
          address2: null,
          // todo
          address3: null,
          postCode: null,
          // Additional
          categoryId: '',
          categoryList2: [],
          categoryList: [{name: 'Private Employer', id: 1},
            {name: 'Local Government Unit', id: 2},
            {name: 'Government Controlled Corp.', id: 3},
            {name: 'National Government Agency', id: 4},],
          categoryListInput:'',
          logoUrl: '',
          briefDescription: '',
          classificationId: '',
          classificationList2: [],
          classificationList: [{name: 'Individual', id: 1},
            {name: 'Non-Individual', id: 2}],
          classificationListInput: '',
          reportHeader: '',
          companySignatory: '',
          tinOfSignatory: '',
          titlePositionOfSIgnatory:'',
          // Statutory Information
          barangay: '',
          sss: '',
          phic: '',
          hdmf: '',
          tin: '',
          rdo: '',
        },
        rules: {
          companyName: [
            { required: true, message: this.$i18n.t('modal_settings_pleaseInputActivityCompanyName'), trigger: 'blur' },
            { min: 5, message: `${this.$i18n.t('modal_settings_lengthShouldBe')} 5`, trigger: 'blur' }
          ],
          email: [
            { required: true, message: this.$i18n.t('modal_settings_pleaseInputEmailAdress'), trigger: 'blur' },
            { type: 'email', message: this.$i18n.t('modal_settings_pleaseInputCorrectEmailAddress'), trigger: 'blur' }
          ],
          currencyCode: [{
            required: true,
            message: this.$i18n.t('modal_settings_currencyCodeIsRequired'),
            trigger: 'blur'
          }],
          // countryId: [{
          //   required: true,
          //   message: 'Country is required',
          //   trigger: 'blur'
          // }],
          // stateId: [{
          //   required: true,
          //   message: 'State is required',
          //   trigger: 'blur'
          // }],
          // cityId: [{
          //   required: true,
          //   message: 'City is required',
          //   trigger: 'blur'
          // }],
          // address: [{
          //   required: true,
          //   message: 'Address is required',
          //   trigger: 'blur'
          // }]
        },
        rulesEdit: {
          name: [
              { required: true, message: this.$i18n.t('modal_settings_pleaseInputActivityCompanyName'), trigger: 'blur' },
              { min: 5, message: `${this.$i18n.t('modal_settings_lengthShouldBe')} 5`, trigger: 'blur' }
          ],
          email: [
              { required: true, message: this.$i18n.t('modal_settings_pleaseInputEmailAdress'), trigger: 'blur' },
              { type: 'email', message: this.$i18n.t('modal_settings_pleaseInputCorrectEmailAddress'), trigger: 'blur' }
          ],
          currencyCode: [{
              required: true,
              message: this.$i18n.t('modal_settings_currencyCodeIsRequired'),
              trigger: 'blur'
          }],
          categoryId: [
              { required: true, message: 'Please input Category', trigger: 'change' }
          ],
          classificationId: [
              { required: true, message: 'Please input Classification', trigger: 'change' }
          ],
          // countryId: [{
          //   required: true,
          //   message: 'Country is required',
          //   trigger: 'blur'
          // }],
          // stateId: [{
          //   required: true,
          //   message: 'State is required',
          //   trigger: 'blur'
          // }],
          // cityId: [{
          //   required: true,
          //   message: 'City is required',
          //   trigger: 'blur'
          // }],
          // address: [{
          //   required: true,
          //   message: 'Address is required',
          //   trigger: 'blur'
          // }]
        },
        // Tree
        // gridOptions: null,
        // gridApi: null,
        // Info
        disabledBtn: true,
        info: {
          id: '',
          name: '',
          code: ''
        },
        activeEditModalTab: 'general',
        links:[],
        isEmptyCategory:false,
        isEmptyClassification:false,
      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      // add
      setState(id) {
        this.form.stateId = null
        this.form.cityId = null

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
        // https://dev.taskbank.io/api/v1/companies/directories?operation=update
          .post(`/api/v1/companies/directories?operation=getStateList&countryId=${id}`)
          .then(response => {
            console.log('---ADD VENDOR LIST', response.data);
            // this.arrCountryId = response.data.countryList
            this.arrStateId = response.data.stateList
            // this.arrCityId = response.data.cityList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      setCity(id) {
        this.form.cityId = null

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companies/directories?operation=getCityList&stateId=${id}`)
          .then(response => {
            console.log('---ADD VENDOR LIST', response.data);
            // this.arrCountryId = response.data.countryList
            // this.arrStateId = response.data.stateList
            this.arrCityId = response.data.cityList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      // edit
      setStateUpdate(id) {
        this.formGet.stateId = null
        this.formGet.cityId = null

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companies/directories?operation=getStateList&countryId=${id}`)
          .then(response => {
            console.log('---ADD VENDOR LIST', response.data);
            // this.arrCountryId = response.data.countryList
            this.arrStateId = response.data.stateList
            // this.arrCityId = response.data.cityList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      setCityUpdate(id) {
        this.formGet.cityId = null

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companies/directories?operation=getCityList&stateId=${id}`)
          .then(response => {
            console.log('---ADD VENDOR LIST', response.data);
            // this.arrCountryId = response.data.countryList
            // this.arrStateId = response.data.stateList
            this.arrCityId = response.data.cityList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      handleExport(index, row) {
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios
        //     .get(`/api/v1/companies/export?companyId=${this.$route.query.companyId}`)
        //     .then(response => {
        //         console.log('---/companies/export', response.data);
        //     })
        //     .catch(error => {
        //         console.log('An error occurred:', error);
        //     });
      },
      querySearchCategory(queryString, cb){
        console.log(queryString, {cb})
        // var links = this.links;
        var links = this.formGet.categoryList;
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        // call callback function to return suggestion objects
        console.log(results)
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if(results.length < 1){
            this.isEmptyCategory = true
            this.formGet.categoryId = ''
          }else{
            this.isEmptyCategory = false
          }
          results.forEach(val => {
            if(val.name !== queryString){
              this.isEmptyCategory = true
            }else if(val.name == queryString){
              this.isEmptyCategory = false
            }
          })
          if(this.formGet.categoryListInput === ''){
            this.isEmptyCategory = false
          }
          console.log('results', results)
          cb(results);
        }, 500 * Math.random());
      },
      querySearchClassification(queryString, cb){
        console.log(queryString, {cb})
        // var links = this.links;
        var links = this.formGet.classificationList;
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        // call callback function to return suggestion objects
        console.log(results)
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if(results.length < 1){
            this.isEmptyClassification = true
            this.formGet.classificationId = ''
          }else{
            this.isEmptyClassification = false
          }
          results.forEach(val => {
            if(val.name !== queryString){
              this.isEmptyClassification = true
            }else if(val.name == queryString){
              this.isEmptyClassification = false
            }
          })
          if(this.formGet.classificationListInput === ''){
            this.isEmptyClassification = false
          }
          console.log('results', results)
          cb(results);
        }, 500 * Math.random());
      },
      setNewCategory(newCategory){
        if(newCategory){
          this.formGet.categoryListInput = newCategory.name
          this.formGet.categoryId = newCategory.id
          this.isEmptyCategory = false
        }
      },
      setNewClassification(newClassification){
        if(newClassification){
          this.formGet.classificationListInput = newClassification.name
          this.formGet.classificationId = newClassification.id
          this.isEmptyClassification = false
        }
      },
      createFilter(queryString) {
        return (link) => {
          console.log('link', link)
          return (link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelectCategory(item) {
        this.formGet.categoryListInput = item.name
        this.formGet.categoryId = item.id
        // alert(item.id)
        this.isEmptyCategory = false
        console.log(item);
      },
      handleSelectClassification(item) {
        this.formGet.classificationListInput = item.name
        this.formGet.classificationId = item.id
        this.isEmptyClassification = false
        console.log(item);
      },
      handleIconClickCategory(ev) {
        console.log(ev);
        this.$refs['createCompanyCategoryModal'].openModal()
        this.$refs['createCompanyCategoryModal'].form.name = this.formGet.categoryListInput

        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios
        //   .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=create`)
        //   .then(response => {
        //     console.log('---/companyVendors/directories', response.data);
        //     this.$refs['createCompanyCategoryModal'].openModal()
        //     // this.directories = response.data
        //   })
        //   .catch(error => {
        //     console.log('An error occurred:', error);
        //   });
      },
      handleIconClickClassification(ev) {
        this.$refs['createCompanyClassificationModal'].openModal()
        this.$refs['createCompanyClassificationModal'].form.name = this.formGet.classificationListInput

        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios
        //   .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=create`)
        //   .then(response => {
        //     console.log('---/companyVendors/directories', response.data);
        //     this.$refs['createCompanyCategoryModal'].openModal()
        //     // this.directories = response.data
        //   })
        //   .catch(error => {
        //     console.log('An error occurred:', error);
        //   });
      },
      handleEdit(index, row) {
        // this.activeEditModalTab = 'general'
        this.selectedRowId = row.id
        this.openModalEditCompany(row.id)
      },
      async pay(row){
        try {
          let loader = await this.$loading.show();
          this.$route.query.companyId = row.id;
          await this.$store.dispatch('companyChange', row.id);
          await this.$store.dispatch('toggleActiveCompanyName', row.name);
          await localStorage.setItem('companyId', row.id);
          if (localStorage.getItem('selectedProjectId')){
            await localStorage.removeItem('selectedProjectId')
          }
          if (localStorage.getItem('selectedEngagementId')){
            await localStorage.removeItem('selectedEngagementId')
          }
          if (localStorage.getItem('selectedBusinessUnitId')){
            await localStorage.removeItem('selectedBusinessUnitId')
          }
          await this.$store.dispatch('getCompanyLayout').then(async response => {
            console.log('companyUserId', response);
            let data = {
              companyId: this.$route.query.companyId,
              companyUserId: response.companyUserId
            };
            await this.$socket.emit('companyChanged', data);
            await this.$store.dispatch('getMenuStatistics', row.id);
            await this.closeChat2();
            this.$router.push(`/users?companyId=${row.id}&activeTab=subscriptions`);
            await loader.hide();
          });
        } catch (err){
          console.log(err)
        }
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        // console.log("COLUMN", columnIndex)
        if(columnIndex === 0 || columnIndex === 5){
          return 'align-center'
        }
      },
      headerCellClassName({row, column, rowIndex, columnIndex}){
        if(columnIndex === 0 || columnIndex === 5){
          return 'align-center'
        }
      },
      async cellClick(row, column, event){
        try {
          if(column.index !== 6 && column.index !== 7){
            let loader = await this.$loading.show();
            this.$route.query.companyId = row.id;
            await this.$store.dispatch('companyChange', row.id)
            // localStorage.setItem('companyName', row.name)
            await this.$store.dispatch('toggleActiveCompanyName', row.name)
            // this.putCompanyNameIntoHeader(row.name)
            // console.log('selected row.name', row.name)
            await localStorage.setItem('companyId', row.id)
            if (localStorage.getItem('selectedProjectId')){
              await localStorage.removeItem('selectedProjectId')
            }
            if (localStorage.getItem('selectedEngagementId')){
              await localStorage.removeItem('selectedEngagementId')
            }
            if (localStorage.getItem('selectedBusinessUnitId')){
              await localStorage.removeItem('selectedBusinessUnitId')
            }
            await this.$store.dispatch('getCompanyLayout').then(async response => {
              console.log('companyUserId', response)
              let data = {
                companyId: this.$route.query.companyId,
                companyUserId: response.companyUserId
              };
              await this.$socket.emit('companyChanged', data)
              await this.$store.dispatch('getMenuStatistics', row.id).then(async resp =>{
                await this.closeChat2();
                if(resp.lastProjectId !== null){
                  localStorage.setItem('selectedProjectId', resp.lastProjectId)
                  await this.$router.push(`/projects?companyId=${row.id}&projectId=${resp.lastProjectId}`)
                  await loader.hide()
                }else{
                  await this.$router.push(`/projects?companyId=${row.id}`)
                  await loader.hide()
                }
              })
            });
          }
        }catch (err){
          console.log(err)
        }
      },
      // getContextMenuItems(params) {
      //   var _this = this;
      //   // var data = params.node.data;
      //   var contextMenuItemList = [];
      //       contextMenuItemList.push({
      //         name: 'Edit Company',
      //         action: function () {
      //           _this.openModalEditCompany()
      //         },
      //         icon: '<i class="el-icon-edit"></i>',
      //       })
      //   return contextMenuItemList;
      // },
      submitForm(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            if (this.form.isAddressAssigned == true) {
              if (this.form.countryId &&
                this.form.stateId &&
                this.form.cityId &&
                this.form.address) {
                  if (this.form.website.length > 0) {
                    if (this.form.website.slice(0, 7) != 'http://' && this.form.website.slice(0, 8) != 'https://') {
                      this.form.website = 'http://' + this.form.website
                    }
                  }
                  // TODO:
                  let customFieldsJson = {
                    organization: this.form.companyName,
                    tradingName: this.form.tradingName,
                    businessType: this.form.businessType,
                    // businessDomain: this.form.businessDomain,
                    website: this.form.website,
                    totalEmployess: this.form.totalEmployess,
                    startedOn: this.form.startedOn,
                    primaryPhone: this.form.primaryPhone,
                    fax: this.form.fax,
                    // countryId: this.form.countryId,
                    // stateId: this.form.stateId,
                    // cityId: this.form.cityId,
                  }
                  customFieldsJson = JSON.stringify(customFieldsJson)
                  this.modalAdd = true
                  let loader = this.$loading.show();
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                    .post('/api/v1/companies/create', {
                      name: this.form.companyName,
                      email: this.form.email,
                      currencyId: this.form.currencyCode,
                      customFieldsJson: customFieldsJson,
                      countryId: this.form.countryId,
                      stateId: this.form.stateId,
                      cityId: this.form.cityId,
                      address: this.form.address,
                      address2: this.form.address2,
                      address3: this.form.address3,
                      postCode: this.form.postCode,
                      isAddressAssigned: this.form.isAddressAssigned,
                      taxNumber: this.form.taxNumber,
                      avatarUrl: this.form.logoUrl,
                      financialYearStartDate: this.form.financialYearStartDate,
                    })
                    .then(response => {
                      this.blocking = false
                      if(!this.$route.query.companyId){
                        this.activeCompany = response.data.companyId.toString()
                      }
                      console.log('---', response.data);
                      this.$refs.company.close();
                      this.modalAdd = false
                      // this.notification("Success", "Create company", "success");
                      this.$refs.addSuccess.open();
                      setTimeout(() => {
                        this.$refs.addSuccess.close();
                      }, 4000);
                      this.$store.dispatch('loadUser')
                      this.GetCompanies(response.data.companyId)
                      loader.hide()
                      this.$router.push(`/settings?companyId=${response.data.companyId}`)
                    })
                    .catch(error => {
                      this.modalAdd = false
                      console.log('An error occurred:', error);
                      loader.hide()
                    });
              } else {
                this.$notify({
                  title: 'Notification',
                  message: 'Enter all fields Company Address',
                  type: 'info'
                });
              }
            } else {
              this.form.countryId = null
              this.form.stateId = null
              this.form.cityId = null
              this.form.postCode = null
              this.form.address = null
              this.form.address2 = null
              this.form.address3 = null

              if (this.form.website.length > 0) {
                if (this.form.website.slice(0, 7) != 'http://' && this.form.website.slice(0, 8) != 'https://') {
                  this.form.website = 'http://' + this.form.website
                }
              }
              // TODO:
              let customFieldsJson = {
                organization: this.form.companyName,
                tradingName: this.form.tradingName,
                businessType: this.form.businessType,
                // businessDomain: this.form.businessDomain,
                website: this.form.website,
                totalEmployess: this.form.totalEmployess,
                startedOn: this.form.startedOn,
                primaryPhone: this.form.primaryPhone,
                fax: this.form.fax,
                // countryId: this.form.countryId,
                // stateId: this.form.stateId,
                // cityId: this.form.cityId,
              }
              customFieldsJson = JSON.stringify(customFieldsJson)
              this.modalAdd = true
              let loader = this.$loading.show();
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post('/api/v1/companies/create', {
                  name: this.form.companyName,
                  email: this.form.email,
                  currencyId: this.form.currencyCode,
                  customFieldsJson: customFieldsJson,
                  countryId: this.form.countryId,
                  stateId: this.form.stateId,
                  cityId: this.form.cityId,
                  address: this.form.address,
                  address2: this.form.address2,
                  address3: this.form.address3,
                  postCode: this.form.postCode,
                  isAddressAssigned: this.form.isAddressAssigned,
                  taxNumber: this.form.taxNumber,
                  avatarUrl: this.form.logoUrl,
                  financialYearStartDate: this.form.financialYearStartDate,
                })
                .then(response => {
                  this.blocking = false
                  if(!this.$route.query.companyId){
                    this.activeCompany = response.data.companyId.toString()
                  }
                  console.log('---', response.data);
                  this.$refs.company.close();
                  this.modalAdd = false
                  // this.notification("Success", "Create company", "success");
                  this.$refs.addSuccess.open();
                  setTimeout(() => {
                    this.$refs.addSuccess.close();
                  }, 4000);
                  this.$store.dispatch('loadUser')
                  this.GetCompanies(response.data.companyId)
                  loader.hide()
                  this.$router.push(`/settings?companyId=${response.data.companyId}`)
                })
                .catch(error => {
                  this.modalAdd = false
                  console.log('An error occurred:', error);
                  loader.hide()
                });
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleLogoSuccess( file, fileList ) {
        console.log("FILE",file);
        // this.form.logoUrl = URL.createObjectURL(file.raw);
        console.log('---', this.form.logoUrl);
        var formData = new FormData();
        formData.append('file', file.file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            console.log('---P', response.data);
            this.formGet.logoUrl = response.data.fileUrl
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      handleLogoSuccessAdd( file, fileList ) {
        console.log("FILE",file);
        // this.form.logoUrl = URL.createObjectURL(file.raw);
        console.log('---', this.form.logoUrl);
        var formData = new FormData();
        formData.append('file', file.file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            console.log('---P', response.data);
            this.form.logoUrl = response.data.fileUrl
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      beforeLogoUpload(file){
        const isImage = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/tiff', 'image/webp'].indexOf(file.type) != -1;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isImage) {
          this.$message.error(this.$t('settings_companyAdditionalInfoError_AvatartPictureMustBeJPGFormat'));
        }
        if (!isLt2M) {
          this.$message.error(this.$t('settings_companyAdditionalInfoError_AvatartPictureSizeCanNotExeed2MB'));
        }
        return isImage && isLt2M;
      },
      // showMenu() {
      //   this.open = true
      //   console.log('---', this.open);
      // },
      // hideMenu() {
      //   this.open = false
      //   console.log('---', this.open);
      // },
      // companyName(name) {
      //   this.companyNameSelect = name
      // },
      GetCompanies(companyId){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companies/ownList?companyId=${this.$route.query.companyId || companyId}  `)
          .then(response => {
            console.log('---', response.data);
            this.rowData = response.data.ownListy
            // console.log('---WWW', this.rowData);

            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      openModal() {
        // this.$refs.company.open()

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=create`)
          .then(response => {
            console.log('---/companies/directories', response.data.currencyList);
            this.currencyList = response.data.currencyList
            this.arrCountryId = response.data.countryList
            this.$refs.company.open()
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      openModalEditCompany(id){
        this.modalEdit = true
        this.$refs.editCompany.open();
        console.log("Edit Region")
        this.addRegionToggle = false
        console.log(id)
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=update`)
          .then(response => {
            console.log('---/companies/directories', response.data.currencyList);
            this.currencyList = response.data.currencyList
            this.arrCountryId = response.data.countryList
            // todo
            this.categoryList2 = response.data.category
            this.classificationList2 = response.data.classification

            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            // axios
            //   .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=getStateList&countryId=${this.formGet.countryId}`)
            //   .then(response => {
            //     console.log('---/companyVendors/directories', response.data);
            //     this.arrStateId = response.data.stateList
            //   })
            //   .catch(error => {
            //     console.log('An error occurred:', error);
            //   });

            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            // axios
            //   .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=getCityList&stateId=${this.formGet.stateId}`)
            //   .then(response => {
            //     console.log('---/companyVendors/directories', response.data);
            //     this.arrCityId = response.data.cityList
            //   })
            //   .catch(error => {
            //     console.log('An error occurred:', error);
            //   });

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            // axios.post(`/api/v1/companies/item?companyId=${this.$route.query.companyId}&customCompanyId=${id}`)
            axios.post(`/api/v1/companies/item?companyId=${id}`)
              .then(response => {
                loader.hide()
                this.modalEdit = false
                console.log('---', response.data);
                if (response.data.success){
                  console.log("success", response.data);
                  this.formGet.companyId = response.data.item.id
                  this.formGet.name = response.data.item.name
                  this.formGet.email = response.data.item.email
                  this.formGet.currencyCode = response.data.item.currencyId
                  this.formGet.countryId = response.data.item.countryId
                  this.formGet.stateId = response.data.item.stateId
                  this.formGet.cityId = response.data.item.cityId
                  this.formGet.address = response.data.item.address
                  this.formGet.address2 = response.data.item.address2
                  this.formGet.address3 = response.data.item.address3
                  this.formGet.postCode = response.data.item.postCode
                  this.formGet.isAddressAssigned = response.data.item.isAddressAssigned
                  this.formGet.taxNumber = response.data.item.taxNumber

                  let customFieldsJson = JSON.parse(response.data.item.customFieldsJson)

                  // this.formGet.businessDomain = customFieldsJson.businessDomain
                  this.formGet.website = customFieldsJson.website
                  this.formGet.totalEmployess = customFieldsJson.totalEmployess
                  this.formGet.startedOn = customFieldsJson.startedOn
                  this.formGet.primaryPhone = customFieldsJson.primaryPhone
                  this.formGet.tradingName = customFieldsJson.tradingName
                  this.formGet.financialYearStartDate = response.data.item.financialYearStartDate
                  this.formGet.businessType = customFieldsJson.businessType
                  this.formGet.fax = customFieldsJson.fax

                  // Additional
                  this.formGet.categoryId = response.data.item.additionalInfo.categoryId
                  this.formGet.classificationId = response.data.item.additionalInfo.classifId

                  this.formGet.logoUrl = response.data.item.additionalInfo.avatarUrl
                  this.formGet.briefDescription = response.data.item.additionalInfo.description
                  this.formGet.reportHeader = response.data.item.additionalInfo.header
                  this.formGet.companySignatory = response.data.item.additionalInfo.signatory
                  this.formGet.tinOfSignatory = response.data.item.additionalInfo.tinOfSignatory
                  this.formGet.titlePositionOfSIgnatory = response.data.item.additionalInfo.titlePositionOfSignatory

                  // Statutory Information
                  if (this.formGet.countryId != 103) {
                    this.formGet.barangay = ''
                    this.formGet.sss = ''
                    this.formGet.phic = ''
                    this.formGet.hdmf = ''
                    this.formGet.tin = ''
                    this.formGet.rdo = ''
                  } else {
                    this.formGet.barangay = response.data.item.statutoryInfo.barangay
                    this.formGet.sss = response.data.item.statutoryInfo.sss
                    this.formGet.phic = response.data.item.statutoryInfo.phic
                    this.formGet.hdmf = response.data.item.statutoryInfo.hdmf
                    this.formGet.tin = response.data.item.statutoryInfo.tin
                    this.formGet.rdo = response.data.item.statutoryInfo.rdo
                  }

                  if (this.formGet.countryId !== null) {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                    axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                    axios
                      .post(`/api/v1/companies/directories?operation=getStateList&countryId=${this.formGet.countryId}`)
                      .then(response => {
                        console.log('---/companyVendors/directories', response.data);
                        this.arrStateId = response.data.stateList
                      })
                      .catch(error => {
                        console.log('An error occurred:', error);
                      });
                  }
                  if (this.formGet.stateId !== null) {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                    axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                    axios
                      .post(`/api/v1/companies/directories?operation=getCityList&stateId=${this.formGet.stateId}`)
                      .then(response => {
                        console.log('---/companyVendors/directories', response.data);
                        this.arrCityId = response.data.cityList
                      })
                      .catch(error => {
                        console.log('An error occurred:', error);
                      });
                  }
                }
              })
              .catch(error => {
                loader.hide()
                this.modalEdit = false
                // this.notification("Notification", error.response.data.message, "info")
                console.log('An error occurred:', error);
              });
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editCompany(form){
        this.$refs[form].validate((valid, object) => {

          let name = this.formGet.name
          if (valid) {
            if (this.formGet.isAddressAssigned == true) {
              if (this.formGet.countryId &&
                this.formGet.stateId &&
                this.formGet.cityId &&
                this.formGet.address) {
                  this.modalEdit = true
                  // let selectedRows = this.gridApi.getSelectedRows();
                  if (this.formGet.website.length > 0) {
                    if (this.formGet.website.slice(0, 7) != 'http://' && this.formGet.website.slice(0, 8) != 'https://') {
                      this.formGet.website = 'http://' + this.formGet.website
                    }
                  }
                  let customFieldsJson = {
                    organization: this.formGet.name,
                    tradingName: this.formGet.tradingName,
                    businessType: this.formGet.businessType,
                    // businessDomain: this.formGet.businessDomain,
                    website: this.formGet.website,
                    totalEmployess: this.formGet.totalEmployess,
                    startedOn: this.formGet.startedOn,
                    primaryPhone: this.formGet.primaryPhone,
                    fax: this.formGet.fax,
                    // countryId: this.formGet.countryId,
                    // stateId: this.formGet.stateId,
                    // cityId: this.formGet.cityId,
                  }
                  customFieldsJson = JSON.stringify(customFieldsJson)

                  let statutoryInfo = {}

                  if (this.formGet.countryId != 103) {
                    statutoryInfo = null
                  } else {
                    statutoryInfo = {
                      barangay: this.formGet.barangay,
                      phic: this.formGet.phic,
                      tin: this.formGet.tin,
                      sss: this.formGet.sss,
                      hdmf: this.formGet.hdmf,
                      rdo: this.formGet.rdo,
                    }
                  }

                  let additionalInfo = {
                    categoryId: this.formGet.categoryId,
                    description: this.formGet.briefDescription,
                    header: this.formGet.reportHeader,
                    tinOfSignatory: this.formGet.tinOfSignatory,
                    // avatarUrl: this.formGet.logoUrl,
                    classifId: this.formGet.classificationId,
                    signatory: this.formGet.companySignatory,
                    titlePositionOfSignatory: this.formGet.titlePositionOfSIgnatory,
                  }

                  let data = {
                    avatarUrl: this.formGet.logoUrl,
                    name: this.formGet.name,
                    email: this.formGet.email,
                    currencyId: this.formGet.currencyCode,
                    customFieldsJson: customFieldsJson,
                    countryId: this.formGet.countryId,
                    stateId: this.formGet.stateId,
                    cityId: this.formGet.cityId,
                    address: this.formGet.address,
                    address2: this.formGet.address2,
                    address3: this.formGet.address3,
                    postCode: this.formGet.postCode,
                    isAddressAssigned: this.formGet.isAddressAssigned,
                    taxNumber: this.formGet.taxNumber,
                    financialYearStartDate: this.formGet.financialYearStartDate,
                    statutoryInfo: statutoryInfo,
                    additionalInfo: additionalInfo,
                  }
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios.post(`/api/v1/companies/update?companyId=${this.$route.query.companyId}&customCompanyId=${this.selectedRowId}`, data)
                    .then(response => {
                      this.modalEdit = false
                      console.log('---', response.data);
                      if (response.data.success) {
                        this.$store.dispatch('loadUser')
                        this.GetCompanies();
                        this.notification("Success", "Edit company", "success");
                        // this.$refs.success.open();
                        // setTimeout(() => {
                        //   this.$refs.success.close();
                        // }, 1000);
                        this.$refs.editCompany.close();
                        this.disabledBtn = true;
                        if(this.$route.query.companyId === this.selectedRowId.toString()){
                          this.$store.dispatch('loadUser')
                          this.$store.dispatch('toggleActiveCompanyName', name);
                          // localStorage.setItem('companyName', name)
                          // this.putCompanyNameIntoHeader(name)
                        }
                        // setTimeout(() => {
                        // this.selectCreatedTask(this.selectedRow.id)
                        // }, 1500);
                      }
                    })
                    .catch(error => {
                      this.modalEdit = false
                      // this.notification("Notification", error.response.data.message, "info")
                      // this.$refs.editCompany.close();
                      // if (error.response.data.statusCode == 401) {
                      //   localStorage.clear()
                      //   this.$router.push('/login')
                      // }
                      console.log('An error occurred:', error);
                    });
              } else {
                this.$notify({
                  title: 'Notification',
                  message: 'Enter all fields Company Address',
                  type: 'info'
                });
              }
            } else {
              this.formGet.countryId = null
              this.formGet.stateId = null
              this.formGet.cityId = null
              this.formGet.postCode = null
              this.formGet.address = null
              this.formGet.address2 = null
              this.formGet.address3 = null

              this.modalEdit = true
              // let selectedRows = this.gridApi.getSelectedRows();
              if (this.formGet.website.length > 0) {
                if (this.formGet.website.slice(0, 7) != 'http://' && this.formGet.website.slice(0, 8) != 'https://') {
                  this.formGet.website = 'http://' + this.formGet.website
                }
              }
              let customFieldsJson = {
                organization: this.formGet.name,
                tradingName: this.formGet.tradingName,
                businessType: this.formGet.businessType,
                // businessDomain: this.formGet.businessDomain,
                website: this.formGet.website,
                totalEmployess: this.formGet.totalEmployess,
                startedOn: this.formGet.startedOn,
                primaryPhone: this.formGet.primaryPhone,
                fax: this.formGet.fax,
                // countryId: this.formGet.countryId,
                // stateId: this.formGet.stateId,
                // cityId: this.formGet.cityId,
              }
              customFieldsJson = JSON.stringify(customFieldsJson)

              let statutoryInfo = {}

              if (this.formGet.countryId != 103) {
                statutoryInfo = null
              } else {
                statutoryInfo = {
                  barangay: this.formGet.barangay,
                  phic: this.formGet.phic,
                  tin: this.formGet.tin,
                  sss: this.formGet.sss,
                  hdmf: this.formGet.hdmf,
                  rdo: this.formGet.rdo,
                }
              }

              let additionalInfo = {
                categoryId: this.formGet.categoryId,
                description: this.formGet.briefDescription,
                header: this.formGet.reportHeader,
                tinOfSignatory: this.formGet.tinOfSignatory,
                // avatarUrl: this.formGet.logoUrl,
                classifId: this.formGet.classificationId,
                signatory: this.formGet.companySignatory,
                titlePositionOfSignatory: this.formGet.titlePositionOfSIgnatory,
              }

              let data = {
                avatarUrl: this.formGet.logoUrl,
                name: this.formGet.name,
                email: this.formGet.email,
                currencyId: this.formGet.currencyCode,
                customFieldsJson: customFieldsJson,
                countryId: this.formGet.countryId,
                stateId: this.formGet.stateId,
                cityId: this.formGet.cityId,
                address: this.formGet.address,
                address2: this.formGet.address2,
                address3: this.formGet.address3,
                postCode: this.formGet.postCode,
                isAddressAssigned: this.formGet.isAddressAssigned,
                taxNumber: this.formGet.taxNumber,
                financialYearStartDate: this.formGet.financialYearStartDate,
                statutoryInfo: statutoryInfo,
                additionalInfo: additionalInfo,
              }
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/companies/update?companyId=${this.$route.query.companyId}&customCompanyId=${this.selectedRowId}`, data)
                .then(response => {
                  this.modalEdit = false
                  console.log('---', response.data);
                  if (response.data.success) {
                    this.$store.dispatch('loadUser')
                    this.GetCompanies();
                    this.notification("Success", "Edit company", "success");
                    // this.$refs.success.open();
                    // setTimeout(() => {
                    //   this.$refs.success.close();
                    // }, 1000);
                    this.$refs.editCompany.close();
                    this.disabledBtn = true;
                    if(this.$route.query.companyId === this.selectedRowId.toString()){
                      this.$store.dispatch('loadUser')
                      this.$store.dispatch('toggleActiveCompanyName', name);
                      // localStorage.setItem('companyName', name)
                      // this.putCompanyNameIntoHeader(name)
                    }
                    // setTimeout(() => {
                    // this.selectCreatedTask(this.selectedRow.id)
                    // }, 1500);
                  }
                })
                .catch(error => {
                  this.modalEdit = false
                  // this.notification("Notification", error.response.data.message, "info")
                  // this.$refs.editCompany.close();
                  // if (error.response.data.statusCode == 401) {
                  //   localStorage.clear()
                  //   this.$router.push('/login')
                  // }
                  console.log('An error occurred:', error);
                });
            }
          } else {
            // eslint-disable-next-line no-console
            console.log('validvalidvalidvalid', object)
            if (object.categoryId || object.classificationId) {
              this.activeEditModalTab = 'additional'
            } else {
              this.activeEditModalTab = 'general'
            }
          }
        });
      },
      // selectCreatedTask(id){
      //   this.gridApi.forEachNode(function (node) {
      //     console.log("NODE DATA", node.data.id)
      //     console.log("NODE DATA ID COMPARE", id)
      //     if (node.data.id === id) {
      //       node.setSelected(true);
      //       console.log("NODE SELECTED")
      //     }
      //   });
      // },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      // onGridReady(params) {},
      // onSelectionChanged() {
      //   var selectedRows = this.gridApi.getSelectedRows();
      //   this.selectedRow = selectedRows[0]
      //   this.info.id = selectedRows[0].id;
      //   this.info.name = selectedRows[0].name;
      //   this.info.code = selectedRows[0].code;
      //   this.disabledBtn = false;
      // },
      closeModal(){
        this.$refs['form'].resetFields();
        this.form.postCode = null
        this.form.address = null
        this.form.address2 = null
        this.form.address3 = null
        this.form.isAddressAssigned = false
        this.form.logoUrl = ''
        this.form.financialYearStartDate = null
        // this.form.companyName = ''
        // this.form.email = ''
        // this.form.currencyCode = ''
        // this.form.businessDomain = ''
        // this.form.website = ''
        // this.form.totalEmployess = ''
        // this.form.startedOn = ''
        // this.form.primaryPhone = ''
        // this.form.countryId = null
        // this.form.stateId = null
        // this.form.cityId = null
        // this.form.address = null
        // this.form.address2 = null
        // this.form.tradingName = null
        // this.form.businessType = null
        // this.form.fax = null
      },
      editCompanyclose(){
        this.activeEditModalTab = 'general'
        // this.$refs['editCompany'].resetFields();
        this.formGet.companyId = ''
        this.formGet.name = ''
        this.formGet.categoryId = ''
        this.formGet.categoryList = [{name: 'Private Employer', id: 1},
          {name: 'Local Government Unit', id: 2},
          {name: 'Government Controlled Corp.', id: 3},
          {name: 'National Government Agency', id: 4},],
          this.formGet.classificationId =  '',
          this.formGet.classificationList = [{name: 'Individual', id: 1},
            {name: 'Non-Individual', id: 2}],
          this.formGet.reportHeader = '',
          this.formGet.companySignatory = '',
          this.formGet.logoUrl = ''
        this.formGet.briefDescription = ''
        this.formGet.tinOfSignatory = ''
        this.formGet.titlePositionOfSIgnatory = ''
        this.formGet.email = ''
        this.formGet.currencyCode = ''
        // this.formGet.businessDomain = ''
        this.formGet.website = ''
        this.formGet.totalEmployess = ''
        this.formGet.startedOn = ''
        this.formGet.primaryPhone = ''
        this.formGet.countryId = null
        this.formGet.stateId = null
        this.formGet.cityId = null
        this.formGet.address = null
        this.formGet.address2 = null
        this.formGet.tradingName = null
        this.formGet.financialYearStartDate = null
        this.formGet.businessType = null
        this.formGet.fax = null
        this.formGet.barangay = null
        this.formGet.sss = null
        this.formGet.phic = null
        this.formGet.hdmf = null
        this.formGet.tin = null
        this.formGet.rdo = null
        this.formGet.categoryListInput = ''
      },
      // openDialog(){
      //   this.$emit('openChat2')
      // },
      closeChat2(){
        this.$emit('closeChat2')
      },
      // putCompanyNameIntoHeader(name){
      //   console.log('setting Company from component', name)
      //   this.$emit('putCompanyNameIntoHeader', name)
      // }
    },
    watch:{
      user(val){
        val.companyList.forEach(i =>{
          i.createDate = moment(i.createDate.toString(), 'X').format('DD MMM YYYY')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .companies{
        background: #fff;
        /*height: 100vh;*/
    }

    .content {
        display: flex;
        /*height: 100vh;*/
        /*padding-top: 50px;*/
    }

    // [ Wrapper ] start
    .wrap {
        display: flex;
        justify-content:center;
        width: 100%;
        padding: 0 10px 10px 0;

        &__tree {
            width: 100%;
            /*width: 1200px;*/
            padding: 0 0 10px 0;
        }
        //   &__info {
        //     display: flex;
        //     flex-direction: column;
        //     width: 65%;
        //     padding: 0 0 10px 10px;
        //   }
        &__info-tab {
            height: 50%;
            overflow-y: auto;
            ul {
                margin: 0;
                padding: 0;
                list-style: none;
                li {
                    margin-bottom: 8px;
                    // span {
                    //   font-weight: 500;
                    //   color: #909399;
                    // }
                }
            }
        }
        &__person {
            height: 50%;
        }
    }
    // [ Wrapper ] end
    .company-logo-block{
        /*display:flex;*/
    }
    /deep/.logo-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    /deep/.logo-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    /deep/.logo-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        line-height: 70px !important;
        text-align: center;
    }
    /deep/.logo {
        width: 200px;
        /*height:70px;*/
        display: block;
    }
    // [ Nav tree ] start
    .nav-tree {
        padding-bottom: 10px;
        &__item {
            margin: 0 0 5px 0;
        }
        .el-button {
            margin-right: 10px;
        }
    }
    // [ Nav tree ] end

    // [ Modal ] start
    .button{
        cursor: pointer;
    }
    // [ Modal ] end
    /deep/.modal-edit{
        z-index:999;
        /*.sweet-content-content{*/
        /*!*min-height: 560px*!*/
        /*}*/
        /*.sweet-modal-overlay{*/
        /*z-index:999;*/
        /*}*/
    }
    .form-get{
        min-height:450px;
    }
    /deep/.el-autocomplete{
        width:100%;
        .el-input-group__append{
            background-color: #ecf5ff;
            color: #409EFF;
            border-color: #b3d8ff;
            &:hover{
                background: #409EFF;
                border-color: #409EFF;
                color: #FFF;
            }
        }
    }
</style>

<style>
    .el-table .warning-row {
        cursor:pointer;
        background: oldlace;
    }

    .el-table .success-row {
        cursor:pointer;
        background: #f0f9eb;
    }
    .el-table .align-center{
        text-align:center;
    }
    .table-rows{
        cursor:pointer;
    }
</style>
